import styled from 'styled-components';
import _Stepper from '@mc/components/_partials/stepper';

export const Stepper = styled(_Stepper)`
  margin-bottom: 50px;
`;
